export interface FeatureFlagConfig {
  memberships: boolean;
  contests: boolean;
  contestPost: boolean;
  localJobs: boolean;
  showcase: boolean;
  search: boolean;
  community: boolean;
  referAClient: boolean;
  giveGet: boolean;
  enterprisePage: boolean;
  howItWorksPage: boolean;
  aboutFlnltdPages: boolean;
  projectManagementPage: boolean;
  services: boolean;
  polls: boolean;
  gamification: boolean;
  preferredFreelancerProgram: boolean;
  fileUpload: boolean;
  portfolio: boolean;
}

export enum Feature {
  MEMBERSHIPS = 'memberships',
  CONTESTS = 'contests',
  CONTEST_POST = 'contestPost',
  LOCAL_JOBS = 'localJobs',
  SHOWCASE = 'showcase',
  SEARCH = 'search',
  COMMUNITY = 'community',
  REFER_A_CLIENT = 'referAClient',
  GIVE_GET = 'giveGet',
  HOW_IT_WORKS_PAGE = 'howItWorksPage',
  ENTERPRISE_PAGE = 'enterprisePage',
  ABOUT_FLNLTD_PAGES = 'aboutFlnltdPages',
  PROJECT_MANAGEMENT_PAGE = 'projectManagementPage',
  SERVICES = 'services',
  POLLS = 'polls',
  GAMIFICATION = 'gamification',
  PREFERRED_FREELANCER_PROGRAM = 'preferredFreelancerProgram',
  FILEUPLOAD = 'fileUpload',
  PORTFOLIO = 'portfolio',
}

export enum SiteTheme {
  ARROW = 'arrow',
  DELOITTE = 'deloitte',
}
